module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"objective":"Obiettivo","seeBackstage":"Vedi Backstage"},"en":{"objective":"Objective","seeBackstage":"See Backstage"}}')
  delete Component.options._Ctor
}
